import React from 'react'

export default function UiApprovalStatus(props) {
    
    return (
        <>
        <div className='sba-campaign-approval-status'>
            {props.status == 'Pending' && 
                <div className='sba-campaign-approval-status__pending'>
                    {props.status}
                </div>
            }
            {props.status == 'Approved' && 
                <div className='sba-campaign-approval-status__approved'>
                    {props.status}
                </div>
            }
             {props.status == 'Rejected' && 
                <div className='sba-campaign-approval-status__rejected'>
                    {props.status}
                </div>
            }
        </div>
            
        </>
    )
}
